export const svgIconNames = [
  'user',
  'logout',
  'close-circle',
  'card-edit',
  'info-circle',
  'edit-2'
] as const;
